<template>
  <a-row type="flex">
    <div v-for="(item, index) in employee.investment_partner"
         class="team_employee" :key="index">
      <img :src="item.picture" @click="showmodal(index)">
    </div>
  </a-row>

  <a-modal v-model:visible="modal.visible" @click="close" width="80vw"
           :centered="true" :footer="null">
    <div style="text-align: center">
      <p class="detail_title">{{ modal.name }}</p>
      <img src="../../../assets/image/line.png" style="vertical-align: center; width: 120px; margin-bottom: 10px">
      <p class="detail_page">{{ modal.introduction }}</p>
    </div>
  </a-modal>

</template>

<script>
import {onMounted, reactive} from 'vue'
import axios from "axios";
import {WeiboCircleFilled, WechatFilled,} from '@ant-design/icons-vue'

export default {
  name: 'Team_partner_m',
  components: {WeiboCircleFilled, WechatFilled},
  setup() {
    let employee = reactive({
      investment_partner: [],
    })
    let modal = reactive({
          visible: false,
          name: '',
          introduction: '',
        }
    )
    const showmodal = (index) => {
      modal.visible = true;
      modal.name = employee.investment_partner[index].name
      modal.introduction = employee.investment_partner[index].introduction
    }
    const shareweibo = () => {
      let title = "海纳百川 投资团队"
      let url = encodeURIComponent(window.location.href);
      let sinaurl = 'https://service.weibo.com/share/share.php?url=' + url + '&type=button&language=zh_cn&title=' + title
          + '&searchPic=true&style=number#_loginLayer_1496300586101';
      window.open(sinaurl);
    }
    const close = (e) => {
      console.log(e)
      modal.visible = false
    }

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/partner')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              employee.investment_partner.push(res.data[i])
            }
            employee.investment_partner.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.investment_partner.length; i++) {
              employee.investment_partner[i]['picture'] = 'https://sig-china.com' + employee.investment_partner[i]['picture']
            }
          })
    })

    return {employee, modal, showmodal, close, shareweibo}
  }
}
</script>

<style scoped>
.team_employee {
  width: 50vw;
  height: auto;
  align-items: center;
  justify-content: center;
}

img {
  width: auto;
  height: auto;
  max-width: 50vw;
}

.detail_page {
  color: black;
  white-space: pre-wrap;
  font-size: 16px;
  text-align: left;
  max-height: 60vh;
  overflow-y: scroll;
}

.detail_title {
  margin-top: 2vh;
  color: black;
  font-size: 42px;
  text-align: center;
  margin-bottom: 10px;
}
</style>
